import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import 디지바이스 from "../assets/images/digivice.png";
import useAI from "../hooks/common";
import { Prediction } from "../types/common";
import { getBase64 } from "../utils/common";
import LinkInsta from "./LinkInsta";
import Loading from "./Loading";
import ResultContent from "./ResultContent";
import Share from "./Share";

const Content = () => {
  const [preview, setPreview] = useState<string>();
  const imageRef = useRef<any>(null);
  const { predict, loading } = useAI();
  const [result, setResult] = useState<Prediction>();

  useEffect(() => {
    const asyncFunc = async () => {
      if (!loading && preview && imageRef.current) {
        console.log(imageRef.current);

        const prediction = await predict(imageRef.current);
        setResult(prediction as Prediction);
      }
    };
    asyncFunc();
  }, [preview]);

  return (
    <>
      <Container htmlFor="hidden-input">
        {!preview && <Image src={디지바이스} />}
        {preview && <PreviewImage src={preview} ref={imageRef} />}

        {!loading && (
          <Text>
            눌러서 얼굴 사진을
            <br />
            업로드하세요
          </Text>
        )}

        {loading && <Loading />}
      </Container>

      <HiddenInput
        type="file"
        id="hidden-input"
        disabled={loading}
        accept="image/gif, image/jpeg, image/png"
        onChange={async (e: ChangeEvent<any>) => {
          if (e.target.files[0]) {
            const file = e.target.files[0];

            const base64 = await getBase64(file);
            setPreview(base64);
          }
        }}
      />
      <Share />
      <LinkInsta />
      {result && <ResultContent result={result} />}
    </>
  );
};

export default Content;

const Container = styled.label`
  position: relative;
  background-color: #fff;
  border-radius: 20px;

  border: 3px solid black;

  width: 100%;
  aspect-ratio: 1 / 1;

  max-width: 300px;

  margin: auto;

  text-align: center;

  padding: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  transition: 200ms;
  &:hover {
    opacity: 0.9;
  }

  margin-bottom: 30px;
`;

const Text = styled.div`
  font-size: 18px;
`;

const Image = styled.img`
  width: 150px;

  animation: vibration 500ms infinite;

  @keyframes vibration {
    from {
      transform: rotate(1deg);
    }
    to {
      transform: rotate(-1deg);
    }
  }

  margin-bottom: 20px;
`;

const HiddenInput = styled.input`
  display: none;
`;

const PreviewImage = styled.img`
  width: 100%;
`;
